
export class jamarekObj{
    public id :number;
    public unitName :string ;
    public unitId :string ;
    public quantity :string ;
    public staticUnit :string ;
    public exemptAssets :string ;
    public additionalCode :number|undefined ;
    public fromDb :boolean =false ;
    public totalPrice :number =0 ;
    public description :string;
    public credits :string;
    public note :string;
   
  
    /**
     *
     */
    constructor(id :number,unitName :string,unitId :string,quantity :string,staticUnit :string,additionalCode :number,exemptAssets:string,fromDb=false,totalPrice :number,description:string,credits:string,note:string) {
      this.id=id;
      this.unitName=unitName;
      this.unitName=unitName;
      this.unitId=unitId;
      this.additionalCode=additionalCode;
      this.quantity=quantity;
      this.staticUnit=staticUnit;
      this.exemptAssets=exemptAssets;
      this.fromDb=fromDb;
      this.totalPrice=totalPrice;
      this.description=description;
      this.credits=credits;
      this.note=note;
      
    }
  }